module.exports = __webpack_public_path__ + "static/media/1-5.da47f7d4.webp";